import { m } from '@sohanscript/i18n';
import { PageHero } from '@sohanscript/ui/page-hero';
import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { z } from 'zod';
import { GoToTop } from '#/components/layout/goto-top.tsx';
import { NotesList } from '@/components/notes/notes-list';
import { seo, siteConfig } from '@/lib/config/site';
import { NotesTagFilter } from './-components/notes-tag-filter';

export const Route = createFileRoute('/_main/notes/')({
	component: NotesPage,
	validateSearch: z.object({
		tag: z.string().optional().catch(undefined),
	}),
	loader: async ({ context }) => {
		await context.trpc.note.list.ensureData({ page: 1, perPage: 5 });
	},
	head: () => {
		const tags = seo({
			title: m.nav_notes(),
			description: m.notes_seo_desc(),
			url: `${siteConfig.canonical}/notes`,
		});
		return { meta: tags.meta, links: tags.links };
	},
	headers: () => ({
		'Cache-Control': 'public, max-age=3600, s-maxage=86400',
	}),
});

const fallback = (
	<div className="flex justify-center py-20">
		<div className="size-10 animate-spin rounded-full border-2 border-primary border-t-transparent" />
	</div>
);

function NotesPage() {
	const { tag } = Route.useSearch();
	const navigate = Route.useNavigate();
	const active = tag ?? null;
	return (
		<section className="container pt-10 pb-20 lg:py-20">
			<PageHero
				path="notes"
				status="[STATUS: LIVE]"
				sub={m.notes_sub()}
				meta={m.notes_heading_tagline()}
				metaRight="SECTOR: THOUGHT_CTRL"
			>
				{m.notes_heading()}
			</PageHero>
			<Suspense fallback={fallback}>
				<NotesTagFilter
					value={active}
					onChange={(next) =>
						navigate({
							search: (prev) => ({ ...prev, tag: next ?? undefined }),
							resetScroll: false,
						})
					}
				/>
			</Suspense>
			<Suspense fallback={fallback}>
				<NotesList key={active} tag={active} />
			</Suspense>
			<GoToTop />
		</section>
	);
}
